import {
  ReportDashboardComponentKind,
  ReportDashboardComponentViewMode,
  ReportsTranslations,
  Blueprint,
  DatasetBase,
  Dimension,
  ReportDashboardComponentViewData,
  ReportDashboardMetricOptions,
  SummaryData,
} from '@core/reports-types';
import { SupportedNumberFormat, valueFormatter } from '@core/utils-legacy';

import { hasConversionData } from './shared';

const funnelSummary = (
  component: ReportDashboardComponentViewData,
  dataset: DatasetBase,
  metric: ReportDashboardMetricOptions,
  translations: ReportsTranslations,
): SummaryData => {
  const raw = dataset.getRawData();
  const rawValues = <Array<[Dimension, number[]]>>raw.slice(1);
  const hasConversion = hasConversionData(component.metric);

  const items: SummaryData['items'] = rawValues.map((row, i) => {
    const values = row.slice(1);
    const value = <string>(<unknown>values.slice(-1).pop()); // conversion %
    const rawValue = <number>(<unknown>values[1]); // 2nd dimension numeric value

    return {
      tooltip: false,
      clickable: value !== '-',
      dimensions: {
        primary: row[0],
        secondary: hasConversion ? raw[0][2] : undefined,
      },
      header: {
        primary: row[0]?.name,
        secondary: hasConversion ? `${metric.name}: ${values.pop()}` : metric.xAxis,
      },
      value: hasConversion
        ? value
        : valueFormatter(
            value,
            {
              unitType: dataset.metric.unitType,
              unitPrecision: dataset?.meta?.unitPrecision ?? dataset.metric.unitPrecision,
            },
            translations.i18n,
            {
              number: { format: SupportedNumberFormat.IntlStandard },
            },
          ),
      rawValue,
    };
  });

  return {
    dimensions: raw[0],
    values: <any>raw.slice(1),
    items,
    name: metric.xAxis,
  };
};

export const funnelSummaryBlueprint = (
  translations: ReportsTranslations,
): Blueprint<SummaryData> => ({
  match: {
    kind: ReportDashboardComponentKind.Funnel,
    viewMode: ReportDashboardComponentViewMode.Summary,
  },
  factory: ({ component, dataset: originalDataset, metric, meta }) => {
    let dataset = originalDataset;
    if (meta.truncateDataset) {
      const truncateLength =
        typeof meta.truncateDataset === 'number'
          ? meta.truncateDataset
          : meta.truncateDataset(component, dataset);
      dataset = dataset.truncateDataset('first', truncateLength);
    }

    return {
      vis: funnelSummary(component, dataset, metric, translations),
      dataset,
    };
  },
});
